module.exports = __webpack_public_path__ + "img/gas-mine.85e0dfb6.webp";